// extracted by mini-css-extract-plugin
export default {"marginTop":"uW01ekEvnDwhEnptIMPs","dragZone":"m89_vnvyigvCm4TXSGDm"};